import { render } from "./WritingView.vue?vue&type=template&id=0bad1cd4&ts=true"
import script from "./WritingView.vue?vue&type=script&lang=ts"
export * from "./WritingView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__